import React from 'react'
//import { Link } from 'react-router-dom'
import ContactForm from '../ContactFrom/ContactForm'
import icon1 from '../../images/icon/call-calling.svg'
import icon2 from '../../images/icon/icon-sms.svg'


const ContactSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className="contact pt-85">
                <div className="container">
                    <div className="row pb-130 mt-none-30">
                        <div className="col-lg-8 mt-30">
                            <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form">
                                <h2 className="xb-title">Send us a message</h2>
                                <p className="xb-content">Give us a chance to serve and bring magic to your brand.</p>
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col-lg-4 mt-30">
                            <div className="item-contact_info">
                                <div className="xb-item--inner">
                                    <div className="xb-item--top">
                                        <h3 className="xb-item--title">Contact Info</h3>
                                        <span className="xb-item--hotline"><img src={icon1} alt="" /> +(91) 9121003311</span>
                                        <span className="xb-item--email"><img src={icon2} alt="" />dinesh@bogin.tech</span>
                                        <ul className="social_icons_block list-unstyled ul_li">
                                            <li>
                                                <a onClick={ClickHandler} href="https://www.facebook.com/bogin.tech" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                                    <i className="fab fa-facebook-f"></i>
                                                </a>
                                            </li>
                                            <li><a onClick={ClickHandler} aria-label="Instagram" href="https://www.instagram.com/bogin_tech/"><i className="fab fa-instagram"></i></a></li>
                                            <li>
                                                <a onClick={ClickHandler} href="https://x.com/bogin_tech" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.3872 0H15.9952L10.299 7.20048L17 17H11.7545L7.64298 11.0582L2.94415 17H0.332464L6.42395 9.29688L0 0H5.37853L9.09105 5.43101L13.3872 0ZM12.4711 15.2755H13.9155L4.5917 1.63462H3.0402L12.4711 15.2755Z" fill="#0B1957" />
                                                    </svg>
                                                </a>
                                            </li>
                                            <li>
                                                <a onClick={ClickHandler} href="https://www.linkedin.com/company/bogin-tech/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                                    <i className="fab fa-linkedin-in"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="contact-info_widget">
                                        <h3 className="xb-title">India</h3>
                                        <span className="xb-location">Madhavadhara <br />Visakhapatnam - 530 007</span>
                                    </div>
                                    {/* <div className="contact-info_widget">
                                        <h3 className="xb-title">United States</h3>
                                        <span className="xb-location">12 Buckingham Rd, example <br /> Thwaite, HG3 4 TY, UK Contact</span>
                                    </div> */}
                                    <hr className="breack-line" />
                                    {/* <div className="contact-info_widget">
                                        <h3 className="xb-title">our office open time</h3>
                                        <span className="xb-location">Mon - Sat : 8.00-5.00 <br /> Sunday : Closed</span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gmap_canvas bg-dark">
                {/* <iframe title='map' src="https://maps.google.com/maps?q=2880%20Broadway,%20New%20York&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"></iframe> */}
                <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30399.802441753218!2d83.22050951910751!3d17.745802711491447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a395d53ed2da4e5%3A0xa66c3847a1c8155b!2sMadhavadhara%2C%20Visakhapatnam%2C%20Andhra%20Pradesh%2C%20India!5e0!3m2!1sen!2sus!4v1741899499814!5m2!1sen!2sus" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    )
}

export default ContactSection;